import { Mesh, MeshBasicMaterial, Path, Shape, ShapeGeometry } from 'three';
import { globalStores } from '@/editor/stores';
import BaseModel2d from './BaseModel2d';
import { IPoint2d } from '@/editor/math/IPoint2d';
import HighlightedLine from './highlightedLine';
import { selectedOutlineColor, ENTITY_RENDER_ORDER } from '@/editor/constant/entity';
import { pixelRatio2d } from '@/editor/math/const';

export class RoomHighlightModel extends BaseModel2d {
  private _path: IPoint2d[] = [];
  private _holes: IPoint2d[][] = [];
  constructor() {
    super();
    this.setDisplayOrder(ENTITY_RENDER_ORDER.renderOrderTemp);
    globalStores.editorStateStore.sceneInfo.scene2d.scene.add(this._modelGroup);
  }

  private _createMaskMesh() {
    const geometry = this._createMaskEntGeometry();
    const maskMaterial = new MeshBasicMaterial({
      color: selectedOutlineColor,
      transparent: true,
      opacity: 0.3
    });
    maskMaterial.depthTest = false;
    const maskMesh = new Mesh(geometry, maskMaterial);
    maskMesh.renderOrder = ENTITY_RENDER_ORDER.renderOrderTemp;

    return maskMesh;
  }

  private _createOutline() {
    for (let i = 0; i < this._path.length; i++) {
      const start = this._path[i];
      const end = this._path[(i + 1) % this._path.length];
      const highlightedLine = new HighlightedLine([start, end], ENTITY_RENDER_ORDER.wallOutline);
      highlightedLine.setHighlightedColor(selectedOutlineColor, 1);
      // highlightedLine.highlightedLine.renderOrder = ENTITY_RENDER_ORDER.renderOrderTemp;
      this._modelGroup.add(highlightedLine.highlightedLine);
    }

    for (const hole of this._holes) {
      for (let i = 0; i < hole.length; i++) {
        const start = hole[i];
        const end = hole[(i + 1) % hole.length];
        const highlightedLine = new HighlightedLine([start, end], ENTITY_RENDER_ORDER.floorOutline);
        highlightedLine.setHighlightedColor(selectedOutlineColor, 1);
        // highlightedLine.highlightedLine.renderOrder = ENTITY_RENDER_ORDER.renderOrderTemp;
        this._modelGroup.add(highlightedLine.highlightedLine);
      }
    }
  }

  private _createMaskEntGeometry() {
    const heartShape = new Shape();
    for (let i = 0; i < this._path.length; i++) {
      if (i === 0) {
        heartShape.moveTo(this._path[i].x / pixelRatio2d, this._path[i].y / pixelRatio2d);
      } else {
        heartShape.lineTo(this._path[i].x / pixelRatio2d, this._path[i].y / pixelRatio2d);
      }
    }

    for (const hole of this._holes) {
      const holePath = new Path();
      const len = hole.length;
      for (let i = 0; i < len; i++) {
        if (i === 0) {
          holePath.moveTo(hole[i].x / pixelRatio2d, hole[i].y / pixelRatio2d);
        } else {
          holePath.lineTo(hole[i].x / pixelRatio2d, hole[i].y / pixelRatio2d);
        }
      }

      heartShape.holes.push(holePath);
    }

    return new ShapeGeometry(heartShape);
  }

  update(path: IPoint2d[], holes: IPoint2d[][]) {
    if (!path.length) {
      this.clear();
    } else {
      this._path = path;
      this._holes = holes;
      this._createOutline();
      const maskMesh = this._createMaskMesh();
      this._modelGroup.add(maskMesh);
    }
  }

  override clear() {
    super.clear();
  }
}
